import React, {useEffect, useRef, useState} from 'react'


const useLoadNextOnScrollBottom = (
  paginationRes,
  options,
  loadNextQty = 20
) => {
  const ref = useRef(paginationRes)
  useEffect(() => {
    ref.current = paginationRes
  })

  const [intersectionObserver] = useState(() => {
    return new IntersectionObserver((entries) => {
      const [entry] = entries
      if (entry && entry.intersectionRatio > 0) {
        const {current} = ref
        const {hasNext, isLoadingNext, loadNext} = current
        if (!hasNext || isLoadingNext) return
        loadNext(loadNextQty)
      }
    }, options)
  })
  const lastItemRef = useRef()
  useEffect(() => {
    return () => {
      intersectionObserver.disconnect()
    }
  }, [])
  return (
    React.createElement('div', {
      key: 'loadNext',
      ref: (c) => {
        if (c) {
          intersectionObserver.observe(c)
          lastItemRef.current = c
        } else if (lastItemRef.current) {
          intersectionObserver.unobserve(lastItemRef.current)
        }
      },}
    )
  )
}

export default useLoadNextOnScrollBottom
